import { observeScrollDepth } from '../../utils/observeScrollDepth/observeScrollDepth';
import type { ArticleReadSection } from '../../utils/trackArticleRead/trackArticleRead';
import { trackScrollDepth } from '../../utils/trackScrollDepth/trackScrollDepth';

// Wires scroll-depth milestone tracking to an article surface. Call from a
// component's `$effect` with the current article id; the observer is rebuilt
// whenever the id changes so a client-side navigation to another article starts
// its milestones from scratch.
export const useScrollDepthTracking = ({
	articleId,
	section,
	target,
}: {
	articleId: string | undefined;
	section: ArticleReadSection;
	target?: HTMLElement | Window;
}) => {
	if (!articleId) {
		return;
	}

	return observeScrollDepth({
		target,
		onMilestone: (depth) => {
			trackScrollDepth({ articleId, section, depth });
		},
	});
};
